/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExtensionListModel } from '../models/extension-list-model';
import { ExtensionListResult } from '../models/extension-list-result';
import { ExtensionToggleModel } from '../models/extension-toggle-model';
import { ExtensionToggleResult } from '../models/extension-toggle-result';

@Injectable({
  providedIn: 'root',
})
export class CheckoutExtensionService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation v1CheckoutExtensionsListPost
   */
  static readonly V1CheckoutExtensionsListPostPath = '/v1/checkout/extensions/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CheckoutExtensionsListPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsListPost$Plain$Response(params?: {
    body?: ExtensionListModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExtensionListResult>> {

    const rb = new RequestBuilder(this.rootUrl, CheckoutExtensionService.V1CheckoutExtensionsListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExtensionListResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CheckoutExtensionsListPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsListPost$Plain(params?: {
    body?: ExtensionListModel
  },
  context?: HttpContext

): Observable<ExtensionListResult> {

    return this.v1CheckoutExtensionsListPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExtensionListResult>) => r.body as ExtensionListResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CheckoutExtensionsListPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsListPost$Json$Response(params?: {
    body?: ExtensionListModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExtensionListResult>> {

    const rb = new RequestBuilder(this.rootUrl, CheckoutExtensionService.V1CheckoutExtensionsListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExtensionListResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CheckoutExtensionsListPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsListPost$Json(params?: {
    body?: ExtensionListModel
  },
  context?: HttpContext

): Observable<ExtensionListResult> {

    return this.v1CheckoutExtensionsListPost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExtensionListResult>) => r.body as ExtensionListResult)
    );
  }

  /**
   * Path part for operation v1CheckoutExtensionsTogglePost
   */
  static readonly V1CheckoutExtensionsTogglePostPath = '/v1/checkout/extensions/toggle';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CheckoutExtensionsTogglePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsTogglePost$Plain$Response(params?: {
    body?: ExtensionToggleModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExtensionToggleResult>> {

    const rb = new RequestBuilder(this.rootUrl, CheckoutExtensionService.V1CheckoutExtensionsTogglePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExtensionToggleResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CheckoutExtensionsTogglePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsTogglePost$Plain(params?: {
    body?: ExtensionToggleModel
  },
  context?: HttpContext

): Observable<ExtensionToggleResult> {

    return this.v1CheckoutExtensionsTogglePost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExtensionToggleResult>) => r.body as ExtensionToggleResult)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1CheckoutExtensionsTogglePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsTogglePost$Json$Response(params?: {
    body?: ExtensionToggleModel
  },
  context?: HttpContext

): Observable<StrictHttpResponse<ExtensionToggleResult>> {

    const rb = new RequestBuilder(this.rootUrl, CheckoutExtensionService.V1CheckoutExtensionsTogglePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExtensionToggleResult>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1CheckoutExtensionsTogglePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1CheckoutExtensionsTogglePost$Json(params?: {
    body?: ExtensionToggleModel
  },
  context?: HttpContext

): Observable<ExtensionToggleResult> {

    return this.v1CheckoutExtensionsTogglePost$Json$Response(params,context).pipe(
      map((r: StrictHttpResponse<ExtensionToggleResult>) => r.body as ExtensionToggleResult)
    );
  }

}
